import axios from "axios";
import { getOptions } from "../../helpers/api";

export const evaluation = {

  getInspectorFilters: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/evaluation/InspectorFilters`, { ...headers, cancelToken });
  },
  getInspectorEvaluation: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/evaluation/EvaluateInspectors`, data, { ...headers, cancelToken });
  },
  getSupervisorFilters: (data, cancelToken) => {
    console.log("executing getSupervisorFilters");
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/evaluation/SupervisorFilters`, { ...headers, cancelToken });
  },
  getSupervisorEvaluation: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/evaluation/EvaluateSupervisors`, data, { ...headers, cancelToken });
  },
  getMunicipalityFilters: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/evaluation/MunicipalityFilters`, { ...headers, cancelToken });
  },
  getMunicipalityEvaluation: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/evaluation/EvaluateMunicipality`, data, { ...headers, cancelToken });
  },
};